import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwaLocationsStateModule } from './locations/pwa-locations.state.module';


@NgModule({
  imports: [
    CommonModule,
    PwaLocationsStateModule,
  ],
  providers: [],
})
export class PwaStateModule {}
